import Props from '@service-victoria/component-library/props';
import { lazy } from 'react';

import { TransactionSteps } from 'interfaces/transaction';

import meta from './meta';

const Step: Props.Wizard.Step<TransactionSteps> = {
  ...meta,
  Component: lazy(() => import('./Done'))
};

export { Step };
